import React, { PureComponent } from 'react'
import styled from 'styled-components'
import withResizer from '../../hoc/Resizer'
import Asset from '../../components/asset/Asset'
import { IAssetData } from '../../helpers/data/assetData'

const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	background-color: rgba(60, 60, 60, 1);
	color: white;
	font-size: 50px;
	text-align: center;
	position: relative;
`

const BackgroundContainer = styled.div`
	width: 100%;
	height: 100%;
`

const AnimationContainer = styled.div`
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
`

const ScreenReaderOnly = styled.div`
	position: absolute;
	width: 1px;
	height: 1px;
	padding: 0;
	margin: -1px;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	white-space: nowrap;
	border: 0;
`

export interface ISkin {
	background: IAssetData
	animation: IAssetData
}

interface ICountdownState {
	active: boolean
	countdownNumber: number
}

interface ICountdownProps {
	onComplete: () => void
	skin: ISkin
}

class Countdown extends PureComponent<ICountdownProps, ICountdownState> {
	private timeoutId = 0
	private countdownIntervals: number[] = []

	state = {
		active: true,
		countdownNumber: 3,
	}

	componentDidMount() {		
		this.countdownIntervals.push(
			window.setTimeout(() => this.setState({ countdownNumber: 3 }), 100)
		)
		this.countdownIntervals.push(
			window.setTimeout(() => this.setState({ countdownNumber: 2 }), 1000)
		)
		this.countdownIntervals.push(
			window.setTimeout(() => this.setState({ countdownNumber: 1 }), 2000)
		)
		this.countdownIntervals.push(
			window.setTimeout(() => this.setState({ countdownNumber: 0 }), 3000)
		)

		this.timeoutId = window.setTimeout(() => {
			this.onAnimationComplete()
		}, 4000)
	}

	onAnimationComplete = () => {
		if (this.state.active) {
			this.setState({
				active: false,
			})
			this.props.onComplete()
		}
	}

	render() {
		if (this.state.active) {
			return (
				<Wrapper>
					<BackgroundContainer>
						<Asset asset={this.props.skin.background} />
					</BackgroundContainer>
					<AnimationContainer>
						<Asset onComplete={this.onAnimationComplete} asset={this.props.skin.animation} />
					</AnimationContainer>
					<ScreenReaderOnly role="alert">
						{this.state.countdownNumber > 0 ? `${this.state.countdownNumber}` : 'Go'}
					</ScreenReaderOnly>
				</Wrapper>
			)
		} else {
			return null
		}
	}

	componentWillUnmount() {
		window.clearTimeout(this.timeoutId)
		this.countdownIntervals.forEach((id) => window.clearTimeout(id))
	}
}

export default withResizer(Countdown, 1024, 768)
